import React, { ForwardRefRenderFunction, forwardRef } from "react";

import { SupplyChainOverviewConfigure } from "../../../models/supply.chain.overview.configure";
import OverviewGraph from "../Graph";

interface Props {
  panel: keyof SupplyChainOverviewConfigure;
  style?: React.CSSProperties;
  widget: string;
  [property: string]: any;
}

const OverviewGridItem: ForwardRefRenderFunction<HTMLDivElement, Props> = (props, ref) => {
  const { children, className, panel, style, widget, ...rest } = props;

  return (
    <div className={`grid-item ${className}`} ref={ref} style={style} {...rest}>
      <OverviewGraph panel={panel} widget={widget} />
      {children}
    </div>
  );
};

export default forwardRef(OverviewGridItem);
